<template>
  <div style="position:relative;">
    <div class="rasgado rasgado-top"></div>

    <section class="itinerario-poster" ref="sectionRef">

      <h2 class="poster-title">Itinerario</h2>
 <!-- ✨ TEXTO FINAL -->
      <div class="mensaje-final" ref="mensajeFinalRef">
        <p>
          Agradecemos tu puntualidad.<br>
          ¡No queremos empezar sin ti<br>
          ni que te pierdas ningun<br>
          momento especial! Llega a<br>
          tiempo para compartir cada<br>
          momento especial.          <br>
          <br>

        </p>
      </div>
      <div
        v-for="(evento, index) in eventos"
        :key="evento.nombre"
        class="poster-item"
        :ref="el => itemRefs[index] = el"
      >
        <img :src="evento.icono" class="poster-icon" />

        <p class="poster-text">
          <span class="evento-nombre">{{ evento.nombre }}</span>
          <span class="evento-hora">{{ evento.hora }}</span>
          <span v-if="evento.nota" class="evento-nota">
            {{ evento.nota }}
          </span>
        </p>
      </div>

     

    </section>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',

  setup() {

    const eventos = [
      {
        nombre: 'Ceremonia Religiosa',
        hora: '4:00 PM',
        icono: require('@/assets/iglesia-itinerario1.gif')
      },
      {
        nombre: 'Recepción',
        hora: '5:30 PM',
        icono: require('@/assets/Diseño sin título (50).png')
      },
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)
    const mensajeFinalRef = ref(null)

    onMounted(() => {

      itemRefs.value.forEach((el, index) => {

        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {

          entries.forEach(entry => {

            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              {
                opacity: 1,
                x: 0,
                y: 0,
                scale: 1,
                duration: 1,
                ease: 'power3.out'
              }
            )

            gsap.fromTo(
              text,
              {
                y: 20,
                opacity: 0
              },
              {
                y: 0,
                opacity: 1,
                duration: 1,
                delay: 0.2,
                ease: 'power2.out'
              }
            )

            obs.unobserve(entry.target)

          })

        }, {
          threshold: 0.3,
          rootMargin: '0px 0px -80px 0px'
        })

        observer.observe(el)

      })

      // ✨ MENSAJE FINAL
      if (mensajeFinalRef.value) {

        gsap.set(mensajeFinalRef.value, {
          opacity: 0,
          y: 60,
          scale: 0.95,
          filter: 'blur(8px)'
        })

        const observerMensaje = new IntersectionObserver((entries, obs) => {

          entries.forEach(entry => {

            if (!entry.isIntersecting) return

            gsap.to(mensajeFinalRef.value, {
              opacity: 1,
              y: 0,
              scale: 1,
              filter: 'blur(0px)',
              duration: 1.4,
              ease: 'power3.out'
            })

            obs.unobserve(entry.target)

          })

        }, {
          threshold: 0.25,
          rootMargin: '0px 0px -100px 0px'
        })

        observerMensaje.observe(mensajeFinalRef.value)

      }

    })

    return {
      eventos,
      itemRefs,
      sectionRef,
      mensajeFinalRef
    }
  }
}
</script>

<style scoped>
.itinerario-poster {
  background:#121752;
  padding: 60px 20px 80px;
  text-align: center;
  position: relative;
}

.poster-title {
  font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #ffff;
  margin-bottom: 50px;
}

.poster-item {
  margin-bottom: 42px;
}

.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #ffff;
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: #fff;
  z-index: 5;
  pointer-events: none;
}

.rasgado-top {
  top: 0;
  clip-path: polygon(
    0% 70%,
    18% 55%,
    38% 78%,
    58% 52%,
    78% 75%,
    100% 60%,
    100% 0%,
    0% 0%
  );
}

.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(
    0% 30%,
    18% 45%,
    38% 22%,
    58% 48%,
    78% 25%,
    100% 40%,
    100% 100%,
    0% 100%
  );
}

.evento-hora {
  display: block;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
}

/* ✨ MENSAJE FINAL */
.mensaje-final {
  margin-top: -10px;
  padding: 0 10px;
  margin-bottom: 20px;
}

.mensaje-final p {
  font-family: 'Playfair Display', serif;
  color: #ffffff;
  font-size: 19px;
  line-height: 1.28;
  text-align: center;
  font-weight: 400;
  letter-spacing: 0.5px;
}
</style>